import { render, staticRenderFns } from "./leftnav.vue?vue&type=template&id=519a9886"
import script from "./leftnav.vue?vue&type=script&lang=js"
export * from "./leftnav.vue?vue&type=script&lang=js"
import style0 from "./leftnav.vue?vue&type=style&index=0&id=519a9886&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports